import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { COLORS, FONT } from "../../constants";

const TradeLinkedDialog = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { borderRadius: "4px", p: 1, maxWidth: 400 } }}
  >
    <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 0 }}>
      <CheckCircleOutlineIcon sx={{ color: "#2e7d32", fontSize: 24 }} />
      <Typography
        sx={{ fontWeight: 700, fontSize: FONT.size.md, color: COLORS.themeBlack }}
      >
        Account Already Linked
      </Typography>
    </DialogTitle>
    <DialogContent sx={{ pt: 1.5 }}>
      <Typography
        sx={{ fontSize: FONT.size.sm, color: COLORS.lightText, lineHeight: 1.7 }}
      >
        Your Argus Trade Account is already linked to your Online Profile. You
        can log in and start placing orders at trade pricing right away.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
      <Button
        onClick={onClose}
        sx={{
          textTransform: "none",
          fontSize: FONT.size.sm,
          color: COLORS.lightText,
          fontWeight: 500,
        }}
      >
        Close
      </Button>
      <Button
        variant="contained"
        href="/products/parts"
        sx={{
          backgroundColor: COLORS.themeRed,
          color: COLORS.white,
          textTransform: "none",
          fontSize: FONT.size.sm,
          fontWeight: 600,
          borderRadius: "2px",
          boxShadow: "none",
          "&:hover": { backgroundColor: COLORS.themeRed, boxShadow: "none" },
        }}
      >
        Shop Now
      </Button>
    </DialogActions>
  </Dialog>
);

export default TradeLinkedDialog;
